export default __webpack_public_path__ + "static/media/awaiting1S.a46e4a10.svg";